export const LoaderModule = {
  namespaced: true,

  state: {
    loaders: {
      debugUserAuth: false,
      deletingUser: false,
      gettingAuthor: false,
      gettingProvider: false,
      modifyingUser: false,
      sendingPasswordResetEmail: false,
      updatingProvider: false,
      verifyUser: false
    }
  },

  mutations: {
    setLoaders (state, loaders) {
      for (let key in loaders) {
        state.loaders[key] = loaders[key]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/LoaderModule.js